import {useAuthUserStore} from "@/stores/auth";

/*
 * Subida multipart de vídeos a S3 privado con URLs prefirmadas (API V2, LMS-080).
 * El navegador sube cada parte directamente a S3; la API solo firma y cierra.
 */
const uploadsUrl = '/v2/videos/uploads'

export default {
    // Devuelve { upload_id, key }.
    initiate(file) {
        return useAuthUserStore().getApiClient.post(uploadsUrl, {
            filename: file.name,
            size: file.size,
            mime_type: file.type,
        })
    },
    // Devuelve { url } prefirmada para subir la parte con PUT.
    signPart(uploadId, key, partNumber) {
        return useAuthUserStore().getApiClient.post(uploadsUrl + '/' + uploadId + '/parts', {
            key,
            part_number: partNumber,
        })
    },
    // Devuelve el fichero registrado: { file_id, ... }.
    complete(uploadId, key, parts) {
        return useAuthUserStore().getApiClient.post(uploadsUrl + '/' + uploadId + '/complete', {
            key,
            parts,
        })
    },
    abort(uploadId, key) {
        return useAuthUserStore().getApiClient.delete(uploadsUrl + '/' + uploadId, {
            data: {key}
        })
    },
}
